import { tv } from '../_lib/utils';
import UserIcon from '../_assets/icons/user.svg';
import { Media, type MediaProps } from '../Media';

const styles = tv({
	slots: {
		base: 'flex items-center rounded-full bg-background-placeholder overflow-hidden justify-center',
		image: 'h-full w-full [&_img]:h-full [&_img]:w-full [&_img]:object-cover',
		icon: 'text-surface-primary',
	},
	variants: {
		size: {
			xs: {
				base: 'h-6 w-6',
				icon: 'h-3 w-3',
			},
			sm: {
				base: 'h-8 w-8',
				icon: 'h-4 w-4',
			},
			md: {
				base: 'h-10 w-10',
				icon: 'h-5 w-5',
			},
			lg: {
				base: 'h-10 w-10 sm:h-12 sm:w-12',
				icon: 'h-5 w-5 sm:h-6 sm:w-6',
			},
			xl: {
				base: 'h-12 w-12 sm:h-14 sm:w-14',
				icon: 'h-6 w-6 sm:h-7 sm:w-7',
			},
			'2xl': {
				base: 'h-14 w-14 sm:h-16 sm:w-16',
				icon: 'h-7 w-7 sm:h-8 sm:w-8',
			},
			'3xl': {
				base: 'h-16 w-16 sm:h-20 sm:w-20',
				icon: 'h-8 w-8 sm:h-10 sm:w-10',
			},
		},
	},
});

export type AvatarProps = MediaProps & {
	className?: string;
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
};

export function Avatar(props: AvatarProps) {
	const size = props.size || 'lg';
	const { base, image, icon } = styles({ size });

	return (
		<div className={base({ className: props.className })} data-component='Avatar'>
			{props.image ? <Media className={image()} image={props.image} /> : <UserIcon className={`${icon()}`} />}
		</div>
	);
}
